var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescritpion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.5H7M4.5 9.5H7M4.5 11.5H7M9 12H10.5C11.3284 12 12 11.3284 12 10.5V3.57214C12 2.81549 11.4367 2.17344 10.6826 2.11085C10.4338 2.09019 10.1841 2.07239 9.93365 2.05746M6.06635 2.05746C6.02322 2.19734 6 2.34596 6 2.5C6 2.77614 6.22386 3 6.5 3H9.5C9.77614 3 10 2.77614 10 2.5C10 2.34596 9.97678 2.19734 9.93365 2.05746M6.06635 2.05746C6.25517 1.44505 6.82561 1 7.5 1H8.5C9.17439 1 9.74483 1.44505 9.93365 2.05746M6.06635 2.05746C5.81591 2.07239 5.56625 2.09019 5.31739 2.11085C4.56333 2.17344 4 2.81549 4 3.57215V5M4 5H1.75C1.33579 5 1 5.33579 1 5.75V13.25C1 13.6642 1.33579 14 1.75 14H8.25C8.66421 14 9 13.6642 9 13.25V5.75C9 5.33579 8.66421 5 8.25 5H4ZM3 7.5H3.005V7.505H3V7.5ZM3 9.5H3.005V9.505H3V9.5ZM3 11.5H3.005V11.505H3V11.5Z",
    stroke: "#5D77A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescritpion);
export default __webpack_public_path__ + "static/media/descritpion.c3dac368b5be13f2ce68428df95462e2.svg";
export { ForwardRef as ReactComponent };